
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 14.51a1.76 1.76 0 01-1.24-.51L.26 1.49A.83.83 0 010 .88.85.85 0 01.26.26.85.85 0 01.88 0a.83.83 0 01.61.26L14 12.76 26.51.26a.86.86 0 011.22 0 .85.85 0 01.27.62.83.83 0 01-.26.61L15.24 14a1.76 1.76 0 01-1.24.51z"}})])
          )
        }
      }
    